import React from 'react';

const AppContext = React.createContext({
    cart: null,
    setCart: () => { },
    menu: null,
    setMenu: () => { },
});

export default AppContext;